import { jsx as d } from "react/jsx-runtime";
import { createContext as c, useContext as l } from "react";
import "../components/layout/Stack/Stack.js";
import "../components/layout/Box/Box.js";
import { styledWithConfig as e } from "../components/layout/Box/utils.js";
import "../index-CZ8zjHGv.js";
import "../components/layout/Center/Center.js";
import "./WindowSize/Dimensions.js";
import "lodash-es";
import "../components/layout/Columns/ColumnsContext.js";
const r = c({});
function h({
  Link: i,
  NavLink: n,
  createPortal: m
}) {
  const a = e(i, {
    shouldForwardProp: (t, o) => ["replace", "state"].includes(t) || o(t)
  }), s = e(n, {
    shouldForwardProp: (t, o) => ["activeStyle", "activeClassName", "exact", "state"].includes(
      t
    ) || o(t)
  });
  return function({ children: o }) {
    return /* @__PURE__ */ d(
      r.Provider,
      {
        value: {
          createPortal: m,
          Link: a,
          NavLink: s
        },
        children: o
      }
    );
  };
}
const D = () => l(r);
export {
  h as default,
  D as useDom
};
